<template>
  <div class='category-view'>
    <!-- 新品 -->
    <div class="category-wrapper" :class="{'none':newGoodTabStatus == 1}" v-if="rightMenuType == 2">
      <banner class="view-componet" />
      <!-- 新品轴 -->
      <new-goods-list  class="view-componet"/>
      <recommend-list  class="view-componet"/>
      <div class="no_data" v-if="newGoodTabStatus==1">
        <no-result :status="newGoodTabStatus" :isCategory="true"></no-result>
      </div>
    </div>
    <BrandItem v-else-if="rightMenuType == 3"></BrandItem>
    <!-- 原有 -->
    <category-item :pageId="pageId" v-else ></category-item>
  </div>  
</template>

<script>
/* ======= 组件 ======= */
import { createNamespacedHelpers } from 'vuex'
import CategoryItem from './components/CategoryItem'
import BrandItem from './components/BrandItem.vue'
import Banner from './components/Banner.vue'
import RecommendList from './components/RecommendList.vue'
import NewGoodsList from './components/NewGoodsList.vue'
import NoResult from '@/pages/commodity/components/NoResult/NoResult.vue'

const { mapState } = createNamespacedHelpers('categoryNav')

export default {
  name: 'categoryRight',
  components: {
    CategoryItem,
    NoResult,
    Banner,
    RecommendList,
    NewGoodsList,
    BrandItem
  },
  props: {
    pageId: [String, Number]
  },
  computed: {
    ...mapState({
      // eslint-disable-next-line no-nested-ternary
      status: state => (state.isReq ? 3 : state.isErr ? 2 : 1),
      categoryId: state => state.categoryId,
      newGoodsTabId: state => state.newGoodsTabId,
      newBannerReqStatus: state => state.newBannerReqStatus,
      newGoodReqStatus: state => state.newGoodReqStatus,
      newRecommdReqStatus: state => state.newRecommdReqStatus,
      rightMenuType: state => state.rightMenuType
    }),
    newGoodTabStatus() {
      // 1-暂无数据 2-加载失败 3-加载中
      return this.newBannerReqStatus == 3 && this.newGoodReqStatus == 3 && this.newRecommdReqStatus == 3 ? 1 : 0
    },
    isNewGoosTab() {
      return this.rightMenuType === 2
    }
  },
  created() {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang='less' scoped>
  .category-view{
    box-sizing: border-box;
    width: 100%;
    flex: 1;
    height: 100%;
    overflow-y: auto;
    background-color: #fff;
    border-radius: 0.12rem 0 0 0;
    .category-wrapper{
      display: flex;
      flex-direction: column;
      width: 100%;
      min-height: 100%;
      // padding: 0.24rem;
      box-sizing: border-box;
      &.none{
        height: 100%;
      }
    }
    .no_data{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
